import React, { useState, useEffect } from "react";
import { FaHourglass, FaHourglassEnd, FaHourglassHalf, FaHourglassStart, FaArrowLeft } from "react-icons/fa6";

const CustomButt = ({ text, rounded = true, handleButtonClick }) => {
  return (
    <button
      onClick={handleButtonClick}
      className={`transition-all bg-[#10c9c0] hover:bg-[#0eb1a9] inline-block ${
        rounded ? "md:rounded-md" : ""
      } text-white font-semibold py-4 px-7 w-full md:w-auto shadow-sm hover:shadow-md transform hover:scale-[1.02] transition-transform`}
    >
      <span>{text}</span>
    </button>
  );
};

const AnimatedHourglass = () => {
  const [currentIcon, setCurrentIcon] = useState(0);
  
  const hourglassIcons = [
    FaHourglassStart, // Full top
    FaHourglassHalf,  // Half way
    FaHourglassEnd,   // Full bottom
    FaHourglass       // Empty/reset
  ];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIcon((prev) => (prev + 1) % hourglassIcons.length);
    }, 800); // Change every 800ms for smooth animation
    
    return () => clearInterval(interval);
  }, []);
  
  const CurrentIcon = hourglassIcons[currentIcon];
  
  return (
    <div className="relative">
      <CurrentIcon 
        className="text-white text-3xl transition-all duration-300 ease-in-out transform"
        style={{
          filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
        }}
      />
      {/* Optional: Add a subtle glow effect */}
      <div className="absolute inset-0 animate-pulse opacity-30">
        <CurrentIcon className="text-white text-3xl" />
      </div>
    </div>
  );
};

const UnderConstruction = () => {
  const handleLinkedInClick = () => {
    window.open('https://www.linkedin.com/company/akiya2/?originalSubdomain=jp', '_blank');
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      // Fallback to home page if no history
      window.location.href = '/';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#10c9c0] to-[#0eb1a9] flex items-center justify-center px-4">
      {/* Go Back Button - removed from here */}
      
      <div className="max-w-2xl w-full">
        {/* Main Content Card */}
        <div className="bg-white rounded-lg shadow-xl p-8 md:p-12 text-center relative">
          {/* Go Back Button */}
          <div className="absolute top-4 right-4">
            <button 
              onClick={handleGoBack}
              className="flex items-center space-x-2 text-[#949995] hover:text-[#000] transition-colors duration-200 group"
            >
              <FaArrowLeft className="text-sm group-hover:-translate-x-1 transition-transform duration-200" />
              <span className="text-sm font-medium underline underline-offset-2 decoration-1 hover:decoration-2 transition-all duration-200">
                Go Back
              </span>
            </button>
          </div>
          <div className="mb-8">
            <div className="w-20 h-20 bg-gradient-to-br from-[#10c9c0] to-[#0eb1a9] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <AnimatedHourglass />
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-[#000] mb-4">
              Alert Service Coming Soon
            </h2>
            
            <div className="w-24 h-1 bg-gradient-to-r from-[#10c9c0] to-[#0eb1a9] mx-auto mb-6 rounded-full"></div>
          </div>

          <div className="space-y-6 mb-8">
            <p className="text-lg text-[#000] leading-relaxed">
              The new alert service is under construction in its final phase. 
              Soon you will be able to see it and get notified about the best Akiya opportunities in Japan.
            </p>
            
            <div className="bg-gradient-to-r from-[#10c9c0]/10 to-[#0eb1a9]/10 rounded-lg p-6 border-l-4 border-[#10c9c0]">
              <p className="text-[#000] text-lg">
                Till then, please feel free to connect with us through LinkedIn for updates and more information about Japan's hidden gems.
              </p>
            </div>
          </div>

          {/* CTA Button */}
          <div className="flex justify-center">
            <CustomButt
              text="Connect with us on LinkedIn"
              handleButtonClick={handleLinkedInClick}
            />
          </div>

          {/* Progress indicator */}
          <div className="mt-8 pt-6 border-t border-[#949995]/30">
            <div className="flex items-center justify-center space-x-2 text-sm text-[#949995]">
              <div className="flex space-x-1">
                <div className="w-2 h-2 bg-[#10c9c0] rounded-full"></div>
                <div className="w-2 h-2 bg-[#10c9c0] rounded-full"></div>
                <div className="w-2 h-2 bg-[#10c9c0] rounded-full"></div>
                <div className="w-2 h-2 bg-[#949995] rounded-full animate-pulse"></div>
              </div>
              <span className="ml-2">Final Phase</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;